export enum LocalEnum {
  user= 'e.user',
  isloggedin= 'e.islogged',
  token= 'e.token',
  tempToken= 'e.temptoken',
  fileToken= 'e.file.server',
  ssOrganization= 'e.ss.organizationId',
  espOrganization= 'e.esp.organizationId',
  inviteCode = 'e.invite',
  version = 'e.v',
  riskDefinitionId= 'e.rid',
  issueDefinitionId= 'e.sid',
  verifyTime = 'e.vtime',
  tourStarted = 'e.tour',
  SubGroupSelection = 'skipSubgroupSelection'
}
